import React, { useState } from "react";
import { Image } from "react-bootstrap";
import IconPlus from "../../../assets/icon-plus.svg";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { VIDEO_FORMATS } from "../../../constant";
import { VideoPlayerModal } from "../modal/videoPlayerModal";
import AttachmentIcon from "../../../assets/attachment-red-icon.svg";

export function DisplayAttachments({
  onTogglePopUp = () => {},
  onRemoveFile = () => {},
  isAgendaAttachment,
  filesArr = [],
  removeRequired = true,
  addAttchementRequired = true,
  classes = "",
  buttonTitle,
  marginleft,
  updatestatusstyle,
  agendadetailcss,
  pragatidetailcss,
  errorClass = "",
  concludedAgenda,
  isMinitryReview = false
}) {
  const [state, setState] = useState({ popUp: false, item: null });
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoTitle, setVideoTitle] = useState(null);
  const onToogleRemovePopUp = value => {
    setState(prevState => {
      return { popUp: !prevState.popUp, item: value };
    });
  };

  const onRemove = () => {
    onRemoveFile(state.item);
    onToogleRemovePopUp(state.item);
  };

  const showVideoPlayerModal = () => {
    return (
      <VideoPlayerModal
        showVideoModal={showVideoModal}
        url={videoUrl}
        videoTitle={videoTitle}
        onClose={() => {
          setShowVideoModal(false);
          setVideoUrl(null);
          setVideoTitle(null);
        }}
      />
    );
  };
  function removeExtension(fileName) {
    const lastDotIndex = fileName.lastIndexOf(".");
    if (lastDotIndex !== -1) {
      return fileName.substring(0, lastDotIndex);
    }
    return fileName; // Return the original filename if no extension is found
  }
  return (
    <section className={`display-attachments-section ${classes}`}>
      <ConfirmationComponent
        show={state.popUp}
        modalClass={"confirmation-modal"}
        saveHandler={onRemove}
        closeHandler={onToogleRemovePopUp}
        content={"Are you sure you want to do this?"}
      />
      {addAttchementRequired ? (
        <div
          className={`add-files ${
            buttonTitle ? "add-attachment" : ""
          } ${errorClass}`}
          onClick={() => onTogglePopUp()}
          style={{
            display: isMinitryReview
              ? filesArr.length === 0
                ? "flex"
                : "none"
              : "inherit"
          }}
        >
          {isAgendaAttachment ? (
            <Image src={AttachmentIcon} alt="Plus Icon" />
          ) : (
            <Image src={IconPlus} alt="Plus Icon" />
          )}
          <div className="add-file-text">
            {buttonTitle ? buttonTitle : "Add"}
          </div>
        </div>
      ) : null}

      {filesArr &&
        filesArr.map(value => {
          //let title = 'Issue_28.10.2021 - Letter to Principal Secretary Cum commissioner GNCTD- Budget allocation'; value.title = title;
          if (value && value !== undefined && Object.keys(value).length !== 0) {
            const extension = value.name.substr(
              value.name.lastIndexOf(".") + 1,
              value.name.length
            );
            const name = value.name.substr(0, value.name.lastIndexOf(".") - 1);
            let attachmentTitle;
            if (value.title !== "" && value.title !== null) {
              attachmentTitle =
                value.title.length > 20
                  ? value.title.substring(0, 20) + "..."
                  : value.title;
            } else {
              attachmentTitle =
                value.name.length > 20
                  ? value.name.substring(0, 20) + "..."
                  : value.name;
            }

            // if (value && value !== undefined && Object.keys(value).length !== 0) {
            //   const extension = value.name.substr(
            //     value.name.lastIndexOf(".") + 1,
            //     value.name.length
            //   );
            // const name = value.name.substr(0, value.name.lastIndexOf(".") - 1);
            return (
              <div
                className="uploaded-file-wrapper"
                style={{
                  marginBottom:
                    filesArr.length >= 5
                      ? "1%"
                      : isMinitryReview && filesArr.length
                      ? "8px"
                      : null,
                  marginTop: filesArr.length >= 5 ? "0.5%" : null,
                  height: isMinitryReview ? "40px" : null
                }}
              >
                <div
                  className="uploaded-file"
                  style={{
                    backgroundColor: "#F2F6FB",
                    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: 0
                  }}
                >
                  {removeRequired ? (
                    <div
                      className="remove-file"
                      onClick={() => onToogleRemovePopUp(value)}
                    />
                  ) : null}
                  <div
                    className={
                      updatestatusstyle
                        ? "file-detail display-attachment"
                        : "file-detail"
                    }
                    style={{
                      display: agendadetailcss ? "block" : null,
                      width: agendadetailcss ? 42 : null
                    }}
                  >
                    <div>
                      {VIDEO_FORMATS.includes(extension) ? (
                        <div className="video-upload-icon" />
                      ) : (
                        <div
                          className={
                            pragatidetailcss
                              ? "upload-icon pragati-upload"
                              : "upload-icon"
                          }
                        >
                          <span>{extension}</span>
                        </div>
                      )}
                    </div>
                    {!VIDEO_FORMATS.includes(extension) ? (
                      <a
                        target="_blank"
                        href={value.s3Url}
                        style={{ margin: marginleft ? 4 : null }}
                      >
                        {removeExtension(attachmentTitle)}
                      </a>
                    ) : (
                      <div
                        className="video-player pl-1"
                        onClick={() => {
                          setShowVideoModal(true);
                          setVideoUrl(value.s3Url);
                          setVideoTitle(value.title || value.name);
                        }}
                      >
                        {value.title || value.name.substring(0, 20)}
                      </div>
                    )}
                    {showVideoModal === true && showVideoPlayerModal()}
                  </div>
                </div>
              </div>
            );
          }
        })}
    </section>
  );
}
